import React from 'react';
import { Box, List, ListItemButton, ListItemText, Badge, Avatar, IconButton, Button } from '@mui/material';
import MailIcon from '@mui/icons-material/Mail';
import FolderIcon from '@mui/icons-material/Folder';
import AddIcon from '@mui/icons-material/Add';
import { useMailboxes } from '../hooks/useMailboxes';
import { useFolders } from '../hooks/useFolders';

export default function MailSidebar({ mailboxId, setMailboxId, folder, setFolder, onAddMailbox }) {
  const { data: mailboxes } = useMailboxes();
  const { data: folders } = useFolders(mailboxId);
  return (
    <Box sx={{ width: 260, borderRight: '1px solid #E5E7EB', bgcolor: '#fff', p: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
        <Avatar><MailIcon /></Avatar>
        <Box>
          <div style={{ fontWeight: 700 }}>Mail</div>
          <div style={{ fontSize: 12, color: '#6B7280' }}>{(mailboxes && mailboxes.length) ? `${mailboxes.length} mailboxes` : 'No mailboxes'}</div>
        </Box>
      </Box>

      <Box sx={{ mb: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
          <div style={{ fontWeight: 600, fontSize: 14 }}>Mailboxes</div>
          <Button 
            size="small" 
            startIcon={<AddIcon />} 
            onClick={onAddMailbox}
            variant="outlined"
            sx={{ textTransform: 'none' }}
          >
            Add
          </Button>
        </Box>
        {(mailboxes || []).map(m => (
          <ListItemButton key={m.id} selected={String(m.id) === String(mailboxId)} onClick={() => { setMailboxId(m.id); setFolder('INBOX'); }}>
            <ListItemText primary={m.displayName || m.email} secondary={m.email} />
          </ListItemButton>
        ))}
      </Box>

      <Box>
        <div style={{ fontWeight: 600, marginBottom: 8 }}>Folders</div>
        <List>
          {(folders || []).map(f => (
            <ListItemButton key={f.path} selected={f.path === folder} onClick={() => setFolder(f.path)}>
              <FolderIcon sx={{ mr: 1 }} />
              <ListItemText primary={f.path} />
              {f.unseen ? <Badge color="primary" badgeContent={f.unseen} /> : null}
            </ListItemButton>
          ))}
        </List>
      </Box>
    </Box>
  );
}
